var React = require('react');

function Time (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.5 0A5.506 5.506 0 000 5.5C0 8.533 2.467 11 5.5 11S11 8.533 11 5.5 8.533 0 5.5 0zm0 9.83A4.335 4.335 0 011.17 5.5 4.335 4.335 0 015.5 1.17 4.334 4.334 0 019.83 5.5 4.334 4.334 0 015.5 9.83zm0 0","key":0}),React.createElement("path",{"d":"M8.366 5.33H5.895V2.358a.453.453 0 10-.906 0v3.425c0 .25.203.453.453.453h2.924a.453.453 0 100-.906zm0 0","key":1})]);
}

Time.defaultProps = {"width":"11","height":"11","viewBox":"0 0 11 11"};

module.exports = Time;

Time.default = Time;
